import { all, create, evaluate } from 'mathjs';
import parametrit from "./yhteiset_parametrit";

function import_functions(math) {
  math.import({
    ...parametrit,
    // Palauttaa korkokustannukset lainasta
    laske_korot(lainasumma, korko, aika) {
      const maksujen_maara = aika * 12;
      const kuukausiKorko = evaluate('(korko / 100) / 12', { korko })
      const scope = {
        lainasumma,
        kuukausikorko: kuukausiKorko,
        maksujen_maara,
      };

      return evaluate('((kuukausikorko * lainasumma * maksujen_maara) / (1 - (1 + kuukausikorko)^(-1 * maksujen_maara))) - lainasumma', scope)
    },
    // Laskee energiamäärän, joka kuluu rakennuksen energiatarpeen energian tuottoon COP arvolla
    laske_tarvittava_energia_cop(energia_tarve, cop) {
      // 48MWh -> 12 MWh(sähkö) + 36 MWh(pumppu) jos cop 3
      // return evaluate('energia_tarve / (1 + cop)', { energia_tarve, cop });
      return evaluate('energia_tarve / cop', { energia_tarve, cop });
    },
    // Laskee nykykulutuksesta rakennuksen energiatarpeen
    laske_energiatarve_nykykulutuksesta_cop(nykykulutus, cop) {
      return evaluate('nykykulutus + nykykulutus * cop', { nykykulutus, cop });
    },
    hae_kaytettava_korko(rakennustyyppi) {
      if (rakennustyyppi === 'okt') {
        return parametrit.korko_okt;
      }

      return parametrit.korko_muut;
    }
  })
}

function create_math() {
  const instance = create(all);
  import_functions(instance);
  return instance;
}

export default create_math;

